function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.737 0h11.305L12.306 34.773A1.803 1.803 0 0110.598 36H1.8a1.8 1.8 0 01-1.706-2.376L11.03 1.227A1.803 1.803 0 0112.737 0z",
  fill: "url(#azure_svg__paint0_linear_7554_42185)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M29.165 23.324H11.238a.83.83 0 00-.567 1.437l11.52 10.752c.335.313.777.487 1.236.487h10.15l-4.412-12.676z",
  fill: "#0078D4"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12.737 0a1.788 1.788 0 00-1.712 1.25L.108 33.595A1.798 1.798 0 001.805 36h9.025a1.93 1.93 0 001.48-1.26l2.178-6.416 7.776 7.253c.326.27.735.42 1.158.423h10.113L29.1 23.324l-12.931.003L24.083 0H12.737z",
  fill: "url(#azure_svg__paint1_linear_7554_42185)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M27.177 1.225A1.8 1.8 0 0025.47 0h-12.6a1.8 1.8 0 011.706 1.225l10.935 32.4A1.8 1.8 0 0123.806 36h12.6a1.8 1.8 0 001.705-2.376l-10.934-32.4z",
  fill: "url(#azure_svg__paint2_linear_7554_42185)"
});

var _ref6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "azure_svg__paint0_linear_7554_42185",
  x1: 16.857,
  y1: 2.668,
  x2: 5.116,
  y2: 37.354,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#114A8B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0669BC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "azure_svg__paint1_linear_7554_42185",
  x1: 20.525,
  y1: 18.833,
  x2: 17.809,
  y2: 19.751,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.3
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.071,
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.321,
  stopOpacity: 0.1
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.623,
  stopOpacity: 0.05
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "azure_svg__paint2_linear_7554_42185",
  x1: 19.031,
  y1: 1.656,
  x2: 31.919,
  y2: 35.993,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3CCBF4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2892DF"
})));

function SvgAzure(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 39 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

export default SvgAzure;